import { Component, Input, OnDestroy } from '@angular/core';
import { PerformanceService } from './performance.service';
import { HttpResponse } from '@angular/common/http';
import { SelectionService } from 'src/app/services/selection.service';
import {
  linechartColors,
  linechartColorsNudgeLite,
} from '../../../utils/variables';
import { MixpanelService } from 'src/app/utils/mixpanel.service';
import { CurrencyFormatterPipe } from 'src/app/pipes/currency-formatter.pipe';
import { TimezoneService } from 'src/app/services/timezone.service';
import { GoogleChartInterface } from 'ng2-google-charts';
import { Subscription } from 'rxjs';
import { DarkmodeService } from 'src/app/services/darkmode.service';
import { UserService } from 'src/app/metrics/user-management/user.service';
import { CoreTargetService } from 'src/app/core/services/target.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { AuthTokenService } from 'src/app/core/services/auth-token.service';
import { CoreCurrencyService } from 'src/app/core/services/currency.service';
import { SidenavService } from 'src/app/sidenav/sidenav.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-performance',
  templateUrl: './performance.component.html',
  styleUrls: ['./performance.component.css'],
  providers: [CurrencyFormatterPipe],
})
export class PerformanceComponent implements OnDestroy {
  constructor(
    private service: PerformanceService,
    private selectorService: SelectionService,
    private mixpanelService: MixpanelService,
    private currencyPipe: CurrencyFormatterPipe,
    private timezoneService: TimezoneService,
    private darkModeService: DarkmodeService,
    private userService: UserService,
    private coreTargetService: CoreTargetService,
    private currencyService: CoreCurrencyService,
    private localStorageService: LocalStorageService,
    private authTokenService: AuthTokenService,
    private sidenavService: SidenavService,
    private translate: TranslateService,
  ) {}
  @Input() params: any = {};

  subs: Subscription = new Subscription();

  linechartsColors = linechartColors;
  linechartColorsNudgeLite = linechartColorsNudgeLite;
  startDate: any;
  endDate: any;
  revUplift: number = 0;
  dailyInfo: any = {};
  timeRangeSelected: any;
  timeRangeSelected_translated: any;
  selectedRangeValueLine: any;
  initialLoader = true;
  nudgeLite = false;

  showATRBarchart_targets: string[] = ['chewy_ca'];
  showATRBarchart: boolean = true;

  showSDLine: boolean = true;

  showDeviationBorderToogle: boolean = false;
  toogleDeviationBorders: boolean = false;

  showNudgeLiteNewData: boolean = true;

  chewyTargets: string[] = ['chewy_ca', 'chewy_demo'];
  isChewyTarget: boolean = false;

  public compareObject: {
    isActive: boolean;
    startDate: string;
    endDate: string;
  } = {
    isActive: false,
    startDate: '',
    endDate: '',
  };

  public comparedResponseData: any = {
    barChartCrDiff: 0,
    barChartCrDiff_color: 0,
    barChartRpvDiff: 0,
    barChartRpvDiff_color: 0,
    barChartAovDiff: 0,
    barChartAovDiff_color: 0,
    barChartAtrDiff: 0,
    barChartAtrDiff_color: 0,
    revUplift: 0,
    revUplift_color: 0,

    incentivesAmount_visits: 0,
    incentivesAmount_visits_color: 0,
    incentivesAmount_orders: 0,
    incentivesAmount_orders_color: 0,
    controlAmount_visits: 0,
    controlAmount_visits_color: 0,
    controlAmount_orders: 0,
    controlAmount_orders_color: 0,

    share_revenueShare: 0,
    share_revenueShare_color: 0,
    share_ordersShare: 0,
    share_ordersShare_color: 0,
    share_trafficShare: 0,
    share_trafficShare_color: 0,
  };

  public demoAccountForTarget: boolean = false;
  private hideForTheseEmails: string[] = [
    'philipp.spreer@elaboratum.de',
    'george@quicksmithconsulting.com',
    'testermell@testermelltestermell',
  ];

  ngOnInit() {
    if (this.params && this.params?.target) {
      this.coreTargetService.setSelectedTarget('target', this.params.target);
      this.startDate = this.params.startDate || '';
      this.endDate = this.params.endDate || '';
      this.incentiveBarChart.selectedPlatform = this.params.device || '';
      this.incentiveBarChart.selectedFilter = this.params.visitType || '';
      this.selectedOutlier = this.params.outlier || 'Default';
      this.authTokenService.setToken(this.params.token || '');
      this.localStorageService.set('startDate', this.params.startDate || '');
      this.localStorageService.set('endDate', this.params.endDate || '');

      this.currencyService.setSelectedCurrency(this.params.currency || '');

      this.getChartInfo();
      return;
    }

    this.subs.add(
      this.sidenavService.getCompareDates().subscribe((res: any) => {
        this.compareObject.isActive = res?.isActive;

        this.compareObject.startDate =
          res.startDate.toISOString() +
          '@' +
          this.timezoneService.getTimezone();
        this.compareObject.endDate =
          res.endDate.toISOString() + '@' + this.timezoneService.getTimezone();

        if (this.compareObject.isActive) {
          this.chartLoader = false;
          this.loadNrIndicator = 0;
          this.getChartInfo(true);
        }
      }),
    );

    this.checkDemoAccount();

    this.mixpanelService.track('Nudge Overview Page Viewed');

    const email: string = this.localStorageService.get('email') || '';
    if (email.includes('@behamics.com')) {
      this.outliers.push('S. Deviation 2');
      this.outliers.push('S. Deviation 3');
      this.showDeviationBorderToogle = true;
    }

    this.selectedOutlier = 'Default';
    const selectedTarget = this.coreTargetService.getSelectedTarget('target');
    if (
      selectedTarget == 'bonprix' ||
      selectedTarget == 'lindtspruengli' ||
      selectedTarget == 'walbusch' ||
      selectedTarget?.includes('gonser') ||
      selectedTarget?.includes('lensplaza')
    ) {
      this.outliers = ['Default', 'S. Deviation 2'];
      this.showDeviationBorderToogle = true;
    }
    if (selectedTarget == 'lindtspruengli') {
      this.selectedOutlier = 'S. Deviation 2';
    }

    this.subs.add(
      this.darkModeService.getDarkMode().subscribe((event: any) => {
        if (event) {
          this.updateChartStyle('dark');
        } else {
          this.updateChartStyle('light');
        }
      }),
    );

    this.previousSelectedStore =
      this.coreTargetService.getSelectedTarget('target');
    this.subs.add(
      this.selectorService.currentMessage.subscribe((message) => {
        this.toogleDeviationBorders = false;

        const selectedTarget =
          this.coreTargetService.getSelectedTarget('target');

        this.isChewyTarget = this.chewyTargets.includes(selectedTarget);

        if (
          selectedTarget == 'bonprix' ||
          selectedTarget == 'lindtspruengli' ||
          selectedTarget == 'walbusch' ||
          selectedTarget?.includes('gonser') ||
          selectedTarget?.includes('lensplaza')
        ) {
          this.outliers = ['Default', 'S. Deviation 2'];
          this.showDeviationBorderToogle = true;
        } else {
          this.outliers = ['Default', 'Adjusted'];
          this.showDeviationBorderToogle = false;
        }
        if (email.includes('@behamics.com')) {
          this.outliers = [
            'Default',
            'Adjusted',
            'S. Deviation 2',
            'S. Deviation 3',
          ];
          this.showDeviationBorderToogle = true;
        }

        if (selectedTarget == 'lindtspruengli') {
          this.selectedOutlier = 'S. Deviation 2';
        } else {
          this.selectedOutlier = 'Default';
        }

        this.selectedStore = message;
        this.startDate = this.localStorageService.get('startDate');
        this.endDate = this.localStorageService.get('endDate');
        this.chartLoader = false;
        this.loadNrIndicator = 0;

        this.nudgeLite = this.localStorageService.get('nudgeLite') || false;
        this.selectedRangeValueLine =
          this.localStorageService.get('rangeValue');

        // If component has KPI with rate filter
        if (this.selectedRangeValueLine == 'thisyear') {
          this.timeRangeSelected = 'this year';
          this.timeRangeSelected_translated = 'phrases.thisyear';
        } else if (this.selectedRangeValueLine == 'thisweek') {
          this.timeRangeSelected = 'this week';
          this.timeRangeSelected_translated = 'phrases.thisweek';
        } else if (this.selectedRangeValueLine == 'last7days') {
          this.timeRangeSelected = 'last 7 days';
          this.timeRangeSelected_translated = 'phrases.last7days';
        } else if (this.selectedRangeValueLine == 'last30days') {
          this.timeRangeSelected = 'last 30 days';
          this.timeRangeSelected_translated = 'phrases.last30days';
        } else if (this.selectedRangeValueLine == 'thismonth') {
          this.timeRangeSelected = 'this month';
          this.timeRangeSelected_translated = 'phrases.thismonth';
        } else if (this.selectedRangeValueLine == 'custom') {
          this.timeRangeSelected =
            'from ' +
            this.formatDateRange(this.startDate) +
            ' - ' +
            this.formatDateRange(this.endDate);

          this.timeRangeSelected_translated = 'phrases.from_date1_date2';
          // this.formatDateRange(this.startDate) +
          //   ' - ' +
          //   this.formatDateRange(this.endDate);
        } else if (this.selectedRangeValueLine == 'today') {
          this.timeRangeSelected = 'today';
          this.timeRangeSelected_translated = 'words.today';
        } else if (this.selectedRangeValueLine == 'yestarday') {
          this.timeRangeSelected = 'yesterday';
          this.timeRangeSelected_translated = 'words.yestarday';
        }

        function days_between(date1: any, date2: any) {
          var getDate1 =
            date1.split('T')[0].slice(5, 7) +
            '/' +
            date1.split('T')[0].slice(8, 10) +
            '/' +
            date1.split('T')[0].slice(0, 4);
          var getDate2 =
            date2.split('T')[0].slice(5, 7) +
            '/' +
            date2.split('T')[0].slice(8, 10) +
            '/' +
            date2.split('T')[0].slice(0, 4);

          const startDate = new Date(getDate1);
          const endDate = new Date(getDate2);
          const diffTime = Math.abs(endDate.valueOf() - startDate.valueOf());
          return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        }

        this.daysDifference = days_between(this.startDate, this.endDate);
        this.targetName = this.coreTargetService.getSelectedTarget('name');

        let date1 = new Date(this.startDate.split('T')[0]);
        let date2 = new Date(this.endDate.split('T')[0]);

        let dayDifference = this.getDayDifference(date1, date2);

        // If component has KPI with rate filter
        if (dayDifference > 60) {
          this.rate = 'month';
          this.isMonthDisabled = false;
        } else if (dayDifference > 2) {
          this.rate = 'day';
          this.isMonthDisabled = true;
        } else {
          this.rate = 'hourly';
          this.isMonthDisabled = true;
        }

        this.previousSelectedStore =
          this.coreTargetService.getSelectedTarget('target');

        if (this.previousSelectedStore != 'raisin') {
          this.raisinInvestmentViewSelected = false;
        }

        if (
          this.selectedStore == 'Volvo Cars' ||
          this.coreTargetService.getSelectedTarget('target') == 'volvocars'
        ) {
          this.volvoTestDrives();
        } else {
          this.isVolvoTestDrive = false;
          this.getChartInfo();
        }

        // if (this.showATRBarchart_targets.includes(this.previousSelectedStore)) {
        //   this.showATRBarchart = true;
        // } else {
        //   this.showATRBarchart = false;
        // }

        if (!message) {
          this.userService.getSettings(this.previousSelectedStore).subscribe({
            next: (settings) => {
              if (Array.isArray(settings) && settings.length > 0) {
                this.nudgeLite = settings[0]?.nudgeLite || false;
              } else {
                this.nudgeLite = false;
              }
              this.runLineChart();
            },
            error: (err: any) => {
              this.nudgeLite = false;
              this.runLineChart();
            },
          });
        } else {
          this.runLineChart();
        }
      }),
    );

    this.incentiveBarChart.selectedPlatform = 'overall';
    this.incentiveBarChart.selectedFilter = 'overall';
    this.incentiveBarChart.selectedRangeValue = 'today';
    this.chartLoader = true;
    this.currentUserRole = this.localStorageService.get('role');

    window.onbeforeunload = () => this.ngOnDestroy();
  }

  private checkDemoAccount() {
    const email: string = this.localStorageService.get('email') || '';
    if (this.hideForTheseEmails.includes(email)) {
      this.demoAccountForTarget = true;
    } else {
      this.demoAccountForTarget = false;
    }
  }

  getDayDifference(date1: any, date2: any) {
    const timestamp1 = date1.getTime();
    const timestamp2 = date2.getTime();

    const differenceInMilliseconds = Math.abs(timestamp2 - timestamp1);

    const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);

    return Math.floor(differenceInDays);
  }

  formatDateRange(date: string) {
    const [isoDate] = date.split('@');
    let d = new Date(isoDate);

    const month = d.toLocaleString('en-US', { month: 'short' });
    const day = d.getDate();

    const suffix =
      day % 10 == 1 && day != 11
        ? 'st'
        : day % 10 == 2 && day != 12
          ? 'nd'
          : day % 10 == 3 && day != 13
            ? 'rd'
            : 'th';

    return `${month} ${day}${suffix}`;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();

    sessionStorage.removeItem('selectedFilter');
    sessionStorage.removeItem('selectedPlatform');
  }

  updateChartStyle(theme: any) {
    if (theme == 'dark') {
      this.incentivesLineChart.options['backgroundColor'] = 'transparent';
      this.incentivesLineChart.options['legend'].textStyle.color = '#fff';
      this.incentivesLineChart.options['vAxis'].gridlineColor = '#3b3a3a';
      this.incentivesLineChart.options['vAxis'].baselineColor = '#3b3a3a';
      this.incentivesLineChart.options['vAxis'].textStyle.color = '#fff';
      this.incentivesLineChart.options['hAxis'].textStyle.color = '#fff';
      this.incentivesLineChart.options['crosshair'].color = '#3b3a3a';

      this.incentivesLineChart.component?.draw(this.incentivesLineChart);
    } else {
      this.incentivesLineChart.options['backgroundColor'] = 'transparent';
      this.incentivesLineChart.options['legend'].textStyle.color = '#666';
      this.incentivesLineChart.options['vAxis'].gridlineColor = '#c0c0c0';
      this.incentivesLineChart.options['vAxis'].baselineColor = '#ededed';
      this.incentivesLineChart.options['vAxis'].textStyle.color = '#666';
      this.incentivesLineChart.options['hAxis'].textStyle.color = '#666';
      this.incentivesLineChart.options['crosshair'].color = '#eeeeee';

      this.incentivesLineChart.component?.draw(this.incentivesLineChart);
    }
  }

  compareYesterday(today: any, yesterday: any) {
    if (!today || !yesterday) return '';
    let todayPercentage = parseFloat(today.replace(/\s/g, ''));
    let yesterdayPercentage = parseFloat(yesterday.replace(/\s/g, ''));

    let difference = todayPercentage - yesterdayPercentage;
    return `${difference.toFixed()}%`;
  }

  firstLoader = false;
  chartLoader = true;
  loadNrIndicator = 0;

  receivedInfoCr: any;
  receivedInfoAtr: any;
  receivedInfoRpv: any;
  receivedInfoAov: any;
  receivedInfoRr: any;
  receivedInfoNrv: any;

  receivedInfoRrNull = false;
  receivedInfoNrNull = false;
  chartCrData: any;
  chartRpvData: any;
  chartAovData: any;
  chartRrData: any;
  chartNrData: any;
  daysDifference = 0;
  totalInfo = {
    total: {
      totalVisits: 0,
      totalOrders: 0,
      totalRevenue: '0',
    },
    share: {
      revenueShare: 0,
      trafficShare: 0,
      ordersShare: 0,
    },
    difference: {
      ordersIncentive: 0,
      ordersControl: 0,
      revenueControl: 0,
      revenueIncentive: 0,
      visitsIncentive: 0,
      visitsControl: 0,
      v: 0,
      vgc: 0,
      o: 0,
      ogc: 0,
    },
  };

  currentUserRole: any;
  selectedStore: any;
  previousSelectedStore: any;
  targetName: any;
  selected = 'overall';

  isVolvoTestDrive: boolean = false;
  testDriveData: any;

  selectedOutlier = 'Default';
  outliers = ['Default', 'Adjusted'];

  rawDataButtonDisabled: boolean = false;

  incentiveData: any;
  chartLoaderSecondary = true;
  isDayDisabled = false;
  isMonthDisabled = true;
  endMaxDate = new Date();
  endMinDate = new Date();
  startMaxDate = new Date();
  selectedRangeValue: any = 'today';
  rate = 'hourly';

  barChartCr: any = [
    {
      name: 'phrases.nudges_overall',
      value: 0,
      height: 0,
      diff: 0,
      tooltip: '',
      default: {},
    },
    {
      name: 'words.control',
      value: 0,
      height: 0,
      diff: 0,
      default: {},
      control: true,
    },
  ];
  barChartCrAxis: any = [];

  barChartRpv: any = [
    {
      name: 'phrases.nudges_overall',
      value: 0,
      height: 0,
      diff: 0,
      tooltip: '',
      default: {},
    },
    {
      name: 'words.control',
      value: 0,
      height: 0,
      diff: 0,
      default: {},
      control: true,
    },
  ];
  barChartRpvAxis: any = [];

  barChartAov: any = [
    {
      name: 'phrases.nudges_overall',
      value: 0,
      height: 0,
      diff: 0,
      tooltip: '',
      default: {},
    },
    {
      name: 'words.control',
      value: 0,
      height: 0,
      diff: 0,
      default: {},
      control: true,
    },
  ];
  barChartAovAxis: any = [];

  barChartAtr: any = [
    {
      name: 'phrases.nudges_overall',
      value: 0,
      height: 0,
      diff: 0,
      tooltip: '',
    },
    {
      name: 'words.control',
      value: 0,
      height: 0,
      diff: 0,
      control: true,
    },
  ];
  barChartAtrAxis: any = [];

  barChartRR: any = [
    {
      name: 'phrases.nudges_overall',
      value: 0,
      height: 0,
      diff: 0,
      tooltip: '',
    },
    {
      name: 'words.control',
      value: 0,
      height: 0,
      diff: 0,
      control: true,
    },
  ];
  barChartRRAxis: any = [];

  barChartNR: any = [
    {
      name: 'phrases.nudges_overall',
      value: 0,
      height: 0,
      diff: 0,
      tooltip: '',
    },
    {
      name: 'words.control',
      value: 0,
      height: 0,
      diff: 0,
      control: true,
    },
  ];
  barChartNRAxis: any = [];

  incentiveBarChart = {
    crorderAmount: {
      incentivesAmount: {
        visits: '',
        orders: '',
      },
      controlAmount: {
        visits: '',
        orders: '',
      },
    },
    platforms: ['All', 'Desktop', 'Tablet', 'Mobile'],
    selectedPlatform: 'overall',
    selectedRangeValue: 'today',
    selectedFilter: 'overall',

    rate: 'hourly',
    onRateChange: function (value: any) {
      // if (
      //   this.selectedRangeValue == 'today' ||
      //   this.selectedRangeValue == 'yesterday'
      // ) {
      //   this.rate = 'hourly';
      // } else {
      //   this.rate = value.value;
      // }
    },
    transactionsListService: null,
  };

  barChartRpr: any = [
    {
      name: 'phrases.nudges_overall',
      value: 0,
      height: 0,
      diff: 0,
      tooltip: '',
      default: {},
    },
    {
      name: 'words.control',
      value: 0,
      height: 0,
      diff: 0,
      default: {},
      control: true,
    },
  ];
  barChartRprAxis: any = [];

  selectedDashboardView: string = 'overall';
  investmentDashboardData: any = {};
  raisinInvestmentViewSelected: boolean = false;

  getChartInfo(compareDates: boolean = false) {
    var device: any;
    if (this.incentiveBarChart.selectedPlatform == 'overall') {
      device = '';
    } else {
      device = this.incentiveBarChart.selectedPlatform;
    }
    var visitType: any;
    if (this.incentiveBarChart.selectedFilter == 'overall') {
      visitType = '';
    } else {
      visitType = this.incentiveBarChart.selectedFilter;
    }

    // Outlier Data
    var outliers: any;
    if (this.selectedOutlier == 'Default') {
      outliers = '';
    } else if (this.selectedOutlier == 'S. Deviation 2') {
      outliers = 's_deviation';
    } else if (this.selectedOutlier == 'S. Deviation 3') {
      outliers = 's_deviation_3';
    } else {
      outliers = true;
    }

    if (!compareDates) {
      this.totalInfo = {
        total: {
          totalVisits: 0,
          totalOrders: 0,
          totalRevenue: '0',
        },
        share: {
          revenueShare: 0,
          trafficShare: 0,
          ordersShare: 0,
        },
        difference: {
          ordersIncentive: 0,
          ordersControl: 0,
          revenueControl: 0,
          revenueIncentive: 0,
          visitsIncentive: 0,
          visitsControl: 0,
          v: 0,
          vgc: 0,
          o: 0,
          ogc: 0,
        },
      };
    }

    setTimeout(() => {
      this.startDate = this.localStorageService.get('startDate');
      this.endDate = this.localStorageService.get('endDate');

      let dateRange = {
        startDate: compareDates ? this.compareObject.startDate : this.startDate,
        endDate: compareDates ? this.compareObject.endDate : this.endDate,
        target: this.coreTargetService.getSelectedTarget('target'),
        device: device,
        visitType: visitType,
      };

      let dateRangeOutliers = {
        startDate: compareDates ? this.compareObject.startDate : this.startDate,
        endDate: compareDates ? this.compareObject.endDate : this.endDate,
        target: this.coreTargetService.getSelectedTarget('target'),
        device: device,
        visitType: visitType,
        noOutliers: outliers,
      };

      if (!this.raisinInvestmentViewSelected) {
        if (this.showATRBarchart) {
          this.getChartAtr(dateRange, compareDates);
        }

        this.getChartCr(
          {
            ...dateRange,
            ...(outliers == 's_deviation' ? { outliersSD: true } : {}),
            ...(outliers == 's_deviation_3' ? { outliersSD3: true } : {}),
          },
          compareDates,
        );
        this.getChartRpv(dateRangeOutliers, compareDates);
        this.getChartRr(dateRange, compareDates);
        this.getChartAov(dateRangeOutliers, compareDates);
        this.getChartNr(dateRange, compareDates);
      } else {
        this.getRaisinInvestmentDashboard(dateRange, compareDates);
      }
    }, 400);
  }

  volvoTestDrives() {
    const data = {
      target: 'volvocars',
      startDate: this.startDate,
      endDate: this.endDate,
    };
    this.service.getVolvoTestDrives(data).subscribe({
      next: (res) => {
        this.testDriveData = res;
        // this.isVolvoTestDrive = true;
        this.getChartInfo();
      },
      error: (e) => {
        this.getChartInfo();
      },
    });
  }

  formatPercentage(val: any) {
    if (isNaN(val) || val == null || val == undefined) {
      return '0%';
    }
    return (val * 100).toFixed(0).toString() + '%';
  }

  generateEvenPoints(data: any, numPoints: any) {
    const validValues = data
      .map((item: any) => item.value)
      .filter(
        (value: any) => value !== null && value !== undefined && !isNaN(value),
      );

    if (validValues.length === 0) {
      console.warn('No valid values to calculate points.');
      return [];
    }

    const maxValue = Math.max(...validValues);
    const minValue = Math.min(...validValues);

    const points = [];

    if (maxValue <= 0) {
      const roundedMin = Math.floor(minValue / 2) * 2;
      const interval = Math.abs(roundedMin) / (numPoints - 1);

      for (let i = 0; i < numPoints; i++) {
        points.push((0 - interval * i).toFixed(0));
      }
    } else {
      const roundedMax = Math.ceil(maxValue / 2) * 2;
      const interval = roundedMax / (numPoints - 1);

      for (let i = 0; i < numPoints; i++) {
        points.push((interval * i).toFixed(0));
      }
    }

    return points;
  }

  setProportionalHeights(data: any, maxHeightPercentage: any) {
    const validValues = data
      .map((item: any) => item.value)
      .filter(
        (value: any) => value !== null && value !== undefined && !isNaN(value),
      );

    const allNegative = validValues.every((value: any) => value < 0);

    const maxValue = allNegative
      ? Math.min(...validValues)
      : Math.max(...validValues);

    data.forEach((item: any) => {
      if (item.value === 0 || item.value == 'NaN' || isNaN(item.value)) {
        item.height = 3;
        item.value = 0;
      } else {
        item.height = (item.value / maxValue) * maxHeightPercentage;
        item.height = Math.round(item.height * 100) / 100;
      }
    });

    return data;
  }

  public calculateRelativeHeight(
    mainValue: number,
    mainHeight: number,
    targetValue: number,
  ): number {
    const scaled = (targetValue / mainValue) * mainHeight;
    return parseFloat(scaled.toFixed(3));
  }

  whichNumberIsBigger(value1: any, value2: any): number {
    const parseStringToNumber = (str: string) => {
      return parseFloat(
        str.replace(' ', '').replace('%', '').replace(/,/g, ''),
      );
    };

    try {
      const aa =
        typeof value1 == 'string' ? parseStringToNumber(value1) : value1;
      const bb =
        typeof value2 == 'string' ? parseStringToNumber(value2) : value2;

      if (aa > bb) {
        return 1;
      }
      if (aa < bb) {
        return 2;
      }
      return 0;
    } catch (err) {
      return 0;
    }
  }

  formatPvalue(num: any, translate: boolean = false) {
    if (translate) {
      if (num == null) {
        num = '';
      } else {
        num = num.toFixed(2);
        if (num <= 0.1) {
          num = {
            score: num,
            label: 'words.significant',
          };
        } else {
          num = {
            score: num,
            label: 'phrases.not_significant',
          };
        }
      }
      return num;
    }

    if (num == null) {
      num = '';
    } else {
      num = num.toFixed(2);
      if (num <= 0.1) {
        num = num + ' (Significant)';
      } else {
        num = num + ' (Not Significant)';
      }
    }
    return num;
  }

  getRaisinInvestmentDashboard(dateRange: any, compareDates: boolean = false) {
    if (dateRange.target != 'raisin') return;

    delete dateRange.visitType;

    this.service.getRaisinInvestmentDashboard(dateRange).subscribe({
      next: (res) => {
        this.combinedLoader(1);

        if (compareDates) {
          // Rev Uplift
          this.comparedResponseData.revUplift =
            (res?.nudge?.RPR - res?.control?.RPR) *
              res?.nudge?.totalRegisters || 0;

          this.comparedResponseData.revUplift_color = this.whichNumberIsBigger(
            this.revUplift,
            this.comparedResponseData.revUplift,
          );

          // CR
          this.comparedResponseData.barChartCrDiff =
            res?.uplift?.investmentCR || '0%';
          this.comparedResponseData.barChartCrDiff_color =
            this.whichNumberIsBigger(
              this.investmentDashboardData?.uplift?.investmentCR,
              this.comparedResponseData.barChartCrDiff,
            );

          // RPV
          this.comparedResponseData.barChartRpvDiff = res?.uplift?.RPV || '0%';
          this.comparedResponseData.barChartRpvDiff_color =
            this.whichNumberIsBigger(
              this.investmentDashboardData?.uplift?.RPV,
              this.comparedResponseData.barChartRpvDiff,
            );

          // RPR
          this.comparedResponseData.barChartRprDiff = res?.uplift?.RPR || '0%';
          this.comparedResponseData.barChartRprDiff_color =
            this.whichNumberIsBigger(
              this.investmentDashboardData?.uplift?.RPV,
              this.comparedResponseData.barChartRprDiff,
            );

          // AOV
          this.comparedResponseData.barChartAovDiff = res?.uplift?.AOV || '0%';
          this.comparedResponseData.barChartAovDiff_color =
            this.whichNumberIsBigger(
              this.investmentDashboardData?.uplift?.AOV,
              this.comparedResponseData.barChartAovDiff,
            );

          this.comparedResponseData.incentivesAmount_visits =
            res?.nudge?.totalVisits;
          this.comparedResponseData.incentivesAmount_visits_color =
            this.whichNumberIsBigger(
              this.investmentDashboardData?.nudge?.totalVisits,
              this.comparedResponseData.incentivesAmount_visits,
            );

          this.comparedResponseData.controlAmount_visits =
            res?.control?.totalVisits;
          this.comparedResponseData.controlAmount_visits_color =
            this.whichNumberIsBigger(
              this.investmentDashboardData?.control?.totalVisits,
              this.comparedResponseData.controlAmount_visits,
            );

          this.comparedResponseData.investment = res?.nudge?.totalInvestments;
          this.comparedResponseData.investment_color = this.whichNumberIsBigger(
            this.investmentDashboardData?.nudge?.totalInvestments,
            this.comparedResponseData.investment,
          );

          this.comparedResponseData.investment_control =
            res?.control?.totalInvestments;
          this.comparedResponseData.investment_control_color =
            this.whichNumberIsBigger(
              this.investmentDashboardData?.control?.totalInvestments,
              this.comparedResponseData.investment_control,
            );

          return;
        }

        this.investmentDashboardData = res;

        this.revUplift =
          (res?.nudge?.RPR - res?.control?.RPR) * res?.nudge?.totalRegisters;

        if (!this.revUplift || isNaN(this.revUplift)) {
          this.revUplift = 0;
        }

        // CR --- start
        this.barChartCr[0].name = 'phrases.nudges_overall';

        this.barChartCr[0].diff = res?.uplift.investmentCR + '%';
        this.barChartCr[0].value = res?.nudge?.investmentCRPercent || 0;
        this.barChartCr[1].value = res?.control?.investmentCRPercent || 0;

        this.barChartCr[0].tooltip = '';
        this.barChartCr[0].tooltip_translate = '';
        // this.barChartCr[0].tooltip = this.formatPvalue(res?.pvalue);
        // this.barChartCr[0].tooltip_translate = this.formatPvalue(
        //   res?.pvalue,
        //   true,
        // );

        this.barChartCrAxis = this.generateEvenPoints(
          this.barChartCr,
          5,
        ).reverse();

        this.barChartCr = this.setProportionalHeights(this.barChartCr, 90);
        // CR --- end

        // RPV --- start
        this.barChartRpv[0].name = 'phrases.nudges_overall';

        this.barChartRpv[0].diff = res?.uplift?.RPV || 0;
        this.barChartRpv[0].value = res?.nudge?.RPV || 0;
        this.barChartRpv[1].value = res?.control?.RPV || 0;

        this.barChartRpv[0].tooltip = '';
        this.barChartRpv[0].tooltip_translate = '';

        this.barChartRpvAxis = this.generateEvenPoints(
          this.barChartRpv,
          5,
        ).reverse();

        this.barChartRpv = this.setProportionalHeights(this.barChartRpv, 90);
        // RPV --- end

        // AOV --- start
        this.barChartAov[0].name = 'phrases.nudges_overall';

        this.barChartAov[0].diff = res?.uplift?.AOV || 0;
        this.barChartAov[0].value = res?.nudge?.AOV || 0;
        this.barChartAov[1].value = res?.control?.AOV || 0;

        this.barChartAov[0].tooltip = '';
        this.barChartAov[0].tooltip_translate = '';

        this.barChartAovAxis = this.generateEvenPoints(
          this.barChartAov,
          5,
        ).reverse();

        this.barChartAov = this.setProportionalHeights(this.barChartAov, 90);

        // AOV --- end

        // RPR --- start
        this.barChartRpr[0].name = 'phrases.nudges_overall';

        this.barChartRpr[0].diff = res?.uplift?.RPR || 0;
        this.barChartRpr[0].value = res?.nudge?.RPR || 0;
        this.barChartRpr[1].value = res?.control?.RPR || 0;

        this.barChartRpr[0].tooltip = '';
        this.barChartRpr[0].tooltip_translate = '';

        this.barChartRprAxis = this.generateEvenPoints(
          this.barChartRpr,
          5,
        ).reverse();

        this.barChartRpr = this.setProportionalHeights(this.barChartRpr, 90);
        // RPR --- end

        try {
          this.comparedResponseData.barChartCrDiff_color =
            this.whichNumberIsBigger(
              this.investmentDashboardData?.uplift?.investmentCR,
              this.comparedResponseData.barChartCrDiff,
            );
          this.comparedResponseData.barChartRpvDiff_color =
            this.whichNumberIsBigger(
              this.investmentDashboardData?.uplift?.RPV,
              this.comparedResponseData.barChartRpvDiff,
            );
          this.comparedResponseData.barChartRprDiff_color =
            this.whichNumberIsBigger(
              this.investmentDashboardData?.uplift?.RPV,
              this.comparedResponseData.barChartRprDiff,
            );
          this.comparedResponseData.barChartAovDiff_color =
            this.whichNumberIsBigger(
              this.investmentDashboardData?.uplift?.AOV,
              this.comparedResponseData.barChartAovDiff,
            );
          this.comparedResponseData.incentivesAmount_visits_color =
            this.whichNumberIsBigger(
              this.investmentDashboardData?.nudge?.totalVisits,
              this.comparedResponseData.incentivesAmount_visits,
            );
          this.comparedResponseData.controlAmount_visits_color =
            this.whichNumberIsBigger(
              this.investmentDashboardData?.control?.totalVisits,
              this.comparedResponseData.controlAmount_visits,
            );
          this.comparedResponseData.investment_color = this.whichNumberIsBigger(
            this.investmentDashboardData?.nudge?.totalInvestments,
            this.comparedResponseData.investment,
          );
          this.comparedResponseData.investment_control_color =
            this.whichNumberIsBigger(
              this.investmentDashboardData?.control?.totalInvestments,
              this.comparedResponseData.investment_control,
            );
        } catch (err) {
          console.log(err);
        }
      },
      error: (err: any) => {
        this.combinedLoader(1);
        console.log(this.translate.instant('phrases.something_went_wrong'));
      },
    });
  }

  increaseDecreaseDiff(incentive: any, control: any, noHTML: boolean = false) {
    let diff = incentive / control - 1;
    diff = diff * 100;

    if (isNaN(diff) || diff === Infinity || diff === -Infinity) {
      return '';
    }

    if (diff < 0) {
      if (noHTML) {
        return '' + diff.toFixed(2).replace('-', '- ') + '%';
      }
      return (
        "<span style='color: #458c30;'>" +
        diff.toFixed(2).replace('-', '- ') +
        '%</span>'
      );
    } else {
      if (noHTML) {
        return '+ ' + diff.toFixed(2) + '%';
      }
      return (
        "<span style='color: #ff9292ed;'>+ " + diff.toFixed(2) + '%</span>'
      );
    }
  }

  getChartCr(dateRange: any, compareDates: boolean = false) {
    function formatNumber(num: any) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }

    this.service.getBarChartCr(dateRange).subscribe((info) => {
      if (compareDates) {
        this.combinedLoader(1);

        if (!this.nudgeLite) {
          this.comparedResponseData.barChartCrDiff = this.increaseDecreaseDiff(
            info.incentives,
            info.control,
            true,
          );
        } else {
          if (info.incentives < 0) {
            this.comparedResponseData.barChartCrDiff =
              '- ' + info.incentives + '%';
          } else {
            this.comparedResponseData.barChartCrDiff = info.incentives + '%';
          }
        }

        this.comparedResponseData.visitsIncentive =
          info?.difference?.[
            `v{d=${this.incentiveBarChart.selectedPlatform},seenI=1}`
          ] ||
          info?.difference?.['v{seenI=1}'] ||
          0;

        this.comparedResponseData.visitsControl =
          info?.difference?.[
            `v{d=${this.incentiveBarChart.selectedPlatform},gC=1,seenI=1}`
          ] ||
          info?.difference?.['v{gC=1,seenI=1}'] ||
          0;

        this.comparedResponseData['v'] = info?.difference?.['v{}'] || 0;
        this.comparedResponseData['vgc'] = info?.difference?.['v{gC=1}'] || 0;

        this.comparedResponseData['o'] = info?.difference?.['o{}'] || 0;
        this.comparedResponseData['ogc'] = info?.difference?.['o{gC=1}'] || 0;

        this.comparedResponseData['ordersControl'] =
          info?.difference?.[
            `o{d=${this.incentiveBarChart.selectedPlatform},gC=1,seenI=1}`
          ] ||
          info?.difference?.['o{gC=1,seenI=1}'] ||
          0;

        this.comparedResponseData['ordersIncentive'] =
          info?.difference?.[
            `o{d=${this.incentiveBarChart.selectedPlatform},seenI=1}`
          ] ||
          info?.difference?.['o{seenI=1}'] ||
          0;

        this.comparedResponseData.incentivesAmount_visits = formatNumber(
          info.incentivesInfo.visits || 0,
        );

        this.comparedResponseData.incentivesAmount_orders = formatNumber(
          info.incentivesInfo.orders || 0,
        );

        this.comparedResponseData.controlAmount_visits = formatNumber(
          info.controlInfo.visits || 0,
        );

        this.comparedResponseData.controlAmount_orders = formatNumber(
          info.controlInfo.orders || 0,
        );

        this.comparedResponseData.barChartCrDiff_color =
          this.whichNumberIsBigger(
            this.barChartCr[0].diff,
            this.comparedResponseData.barChartCrDiff,
          );

        this.comparedResponseData.incentivesAmount_visits_color =
          this.whichNumberIsBigger(
            this.incentiveBarChart.crorderAmount.incentivesAmount.visits,
            this.comparedResponseData.incentivesAmount_visits,
          );

        this.comparedResponseData.incentivesAmount_orders_color =
          this.whichNumberIsBigger(
            this.incentiveBarChart.crorderAmount.incentivesAmount.orders,
            this.comparedResponseData.incentivesAmount_orders,
          );

        this.comparedResponseData.controlAmount_visits_color =
          this.whichNumberIsBigger(
            this.incentiveBarChart.crorderAmount.controlAmount.visits,
            this.comparedResponseData.controlAmount_visits,
          );

        this.comparedResponseData.controlAmount_orders_color =
          this.whichNumberIsBigger(
            this.incentiveBarChart.crorderAmount.controlAmount.orders,
            this.comparedResponseData.controlAmount_orders,
          );

        return;
      }

      this.receivedInfoCr = info;

      if (Object.keys(this.receivedInfoCr.difference).length) {
        this.totalInfo.total.totalVisits = formatNumber(
          this.receivedInfoCr.difference['v{}'] +
            this.receivedInfoCr.difference['v{gC=1}'],
        );
        this.totalInfo.total.totalOrders = formatNumber(
          this.receivedInfoCr.difference['o{}'] +
            this.receivedInfoCr.difference['o{gC=1}'],
        );

        if (
          this.receivedInfoCr.difference[
            `o{d=${this.incentiveBarChart.selectedPlatform},gC=1,seenI=1}`
          ] != undefined
        ) {
          this.totalInfo.difference['ordersControl'] =
            this.receivedInfoCr.difference[
              `o{d=${this.incentiveBarChart.selectedPlatform},gC=1,seenI=1}`
            ];
        } else {
          this.totalInfo.difference['ordersControl'] =
            this.receivedInfoCr.difference['o{gC=1,seenI=1}'];
        }

        if (
          this.receivedInfoCr.difference[
            `o{d=${this.incentiveBarChart.selectedPlatform},seenI=1}`
          ] != undefined
        ) {
          this.totalInfo.difference['ordersIncentive'] =
            this.receivedInfoCr.difference[
              `o{d=${this.incentiveBarChart.selectedPlatform},seenI=1}`
            ];
        } else {
          this.totalInfo.difference['ordersIncentive'] =
            this.receivedInfoCr.difference['o{seenI=1}'];
        }

        if (
          this.receivedInfoCr.difference[
            `v{d=${this.incentiveBarChart.selectedPlatform},seenI=1}`
          ] != undefined
        ) {
          this.totalInfo.difference.visitsIncentive =
            this.receivedInfoCr.difference[
              `v{d=${this.incentiveBarChart.selectedPlatform},seenI=1}`
            ];
        } else {
          this.totalInfo.difference.visitsIncentive =
            this.receivedInfoCr.difference['v{seenI=1}'];
        }
        if (
          this.receivedInfoCr.difference[
            `v{d=${this.incentiveBarChart.selectedPlatform},gC=1,seenI=1}`
          ] != undefined
        ) {
          this.totalInfo.difference.visitsControl =
            this.receivedInfoCr.difference[
              `v{d=${this.incentiveBarChart.selectedPlatform},gC=1,seenI=1}`
            ];
        } else {
          this.totalInfo.difference.visitsControl =
            this.receivedInfoCr.difference['v{gC=1,seenI=1}'];
        }

        this.totalInfo.difference['v'] = this.receivedInfoCr.difference['v{}'];
        this.totalInfo.difference['vgc'] =
          this.receivedInfoCr.difference['v{gC=1}'];

        this.totalInfo.difference['o'] = this.receivedInfoCr.difference['o{}'];
        this.totalInfo.difference['ogc'] =
          this.receivedInfoCr.difference['o{gC=1}'];
      }

      if (info.incentives == null) {
        info.incentives = 0;
      }
      if (info.control == null) {
        info.control = 0;
      }

      var tmpData = [];

      if (this.isVolvoTestDrive) {
        tmpData.push(
          (this.testDriveData.crIncentive * 100).toFixed(2),
          (this.testDriveData.crControl * 100).toFixed(2),
        );

        this.barChartCr[0].value = (
          this.testDriveData.crIncentive * 100
        ).toFixed(2);
        this.barChartCr[1].value = (this.testDriveData.crControl * 100).toFixed(
          2,
        );

        this.barChartCr[0].diff = this.increaseDecreaseDiff(
          (this.testDriveData.crIncentive * 100).toFixed(2),
          (this.testDriveData.crControl * 100).toFixed(2),
          true,
        );
      } else {
        tmpData.push(info.incentives, info.control);

        this.barChartCr[0].value = info.incentives;
        this.barChartCr[1].value = info.control;

        this.barChartCr[0].tooltip = this.formatPvalue(info.p);
        this.barChartCr[0].tooltip_translate = this.formatPvalue(info.p, true);

        if (!this.nudgeLite) {
          this.barChartCr[0].diff = this.increaseDecreaseDiff(
            info.incentives,
            info.control,
            true,
          );
        } else {
          if (info.incentives < 0) {
            this.barChartCr[0].diff = '- ' + info.incentives + '%';
          } else {
            this.barChartCr[0].diff = info.incentives + '%';
          }
        }
      }

      if (this.isChewyTarget) {
        this.barChartCr[0].name = 'phrases.test_overall';
      } else {
        this.barChartCr[0].name = 'phrases.nudges_overall';
      }

      this.barChartCrAxis = this.generateEvenPoints(
        this.barChartCr,
        5,
      ).reverse();

      this.barChartCr = this.setProportionalHeights(this.barChartCr, 90);

      if (
        this.receivedInfoCr?.defaultObject &&
        (this.selectedOutlier.includes('S. Deviation') ||
          this.selectedOutlier.includes('Default'))
      ) {
        try {
          const height = this.calculateRelativeHeight(
            this.barChartCr[0].value,
            this.barChartCr[0].height,
            this.receivedInfoCr?.defaultObject?.incentives,
          );

          let absHeight = Math.abs(
            parseFloat((this.barChartCr[0].height - height).toFixed(3)),
          );

          let bottom = parseFloat((height - absHeight).toFixed(3));
          let isLower = false;
          if (
            this.barChartCr[0].value >
            this.receivedInfoCr?.defaultObject?.incentives
          ) {
            isLower = true;
            bottom = parseFloat(
              (this.barChartCr[0].height - absHeight).toFixed(3),
            );
          }

          if (bottom + absHeight > 120) {
            absHeight = 120 - bottom;
          }

          this.barChartCr[0].default = {
            value: this.receivedInfoCr?.defaultObject?.incentives,
            height: absHeight,
            bottom: bottom,
            negative: isLower,
          };

          if (this.barChartCr[1]) {
            const height2 = this.calculateRelativeHeight(
              this.barChartCr[1].value,
              this.barChartCr[1].height,
              this.receivedInfoCr?.defaultObject?.control,
            );

            let absHeight2 = Math.abs(
              parseFloat((this.barChartCr[1].height - height2).toFixed(3)),
            );

            let bottom2 = parseFloat((height2 - absHeight2).toFixed(3));
            let isLower2 = false;
            if (
              this.barChartCr[1].value >
              this.receivedInfoCr?.defaultObject?.control
            ) {
              isLower2 = true;
              bottom2 = parseFloat(
                (this.barChartCr[1].height - absHeight2).toFixed(3),
              );
            }

            if (bottom2 + absHeight2 > 120) {
              absHeight2 = 120 - bottom2;
            }

            this.barChartCr[1].default = {
              value: this.receivedInfoCr?.defaultObject?.control,
              height: absHeight2,
              bottom: bottom2,
              negative: isLower2,
            };
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          this.barChartCr[0].default = null;

          if (this.barChartCr[1]) {
            this.barChartCr[1].default = null;
          }
        } catch (e) {
          console.log(e);
        }
      }

      if (this.isVolvoTestDrive) {
        this.incentiveBarChart.crorderAmount.incentivesAmount.visits =
          formatNumber(this.testDriveData.matchedIncentive);

        this.incentiveBarChart.crorderAmount.incentivesAmount.orders =
          formatNumber(this.testDriveData.bookedIncentive);

        this.incentiveBarChart.crorderAmount.controlAmount.visits =
          formatNumber(this.testDriveData.matchedControl);

        this.incentiveBarChart.crorderAmount.controlAmount.orders =
          formatNumber(this.testDriveData.bookedControl);
      } else {
        if (info.incentivesInfo.visits != null) {
          this.incentiveBarChart.crorderAmount.incentivesAmount.visits =
            formatNumber(info.incentivesInfo.visits);
        } else {
          this.incentiveBarChart.crorderAmount.incentivesAmount.visits = '0';
        }
        if (info.incentivesInfo.orders != null) {
          this.incentiveBarChart.crorderAmount.incentivesAmount.orders =
            formatNumber(info.incentivesInfo.orders);
        } else {
          this.incentiveBarChart.crorderAmount.incentivesAmount.orders = '0';
        }
        if (info.controlInfo.visits != null) {
          this.incentiveBarChart.crorderAmount.controlAmount.visits =
            formatNumber(info.controlInfo.visits);
        } else {
          this.incentiveBarChart.crorderAmount.controlAmount.visits = '0';
        }
        if (info.controlInfo.orders != null) {
          this.incentiveBarChart.crorderAmount.controlAmount.orders =
            formatNumber(info.controlInfo.orders);
        } else {
          this.incentiveBarChart.crorderAmount.controlAmount.orders = '0';
        }
      }

      if (this.compareObject.isActive) {
        this.comparedResponseData.barChartCrDiff_color =
          this.whichNumberIsBigger(
            this.barChartCr[0].diff,
            this.comparedResponseData.barChartCrDiff,
          );

        this.comparedResponseData.incentivesAmount_visits_color =
          this.whichNumberIsBigger(
            this.incentiveBarChart.crorderAmount.incentivesAmount.visits,
            this.comparedResponseData.incentivesAmount_visits,
          );

        this.comparedResponseData.incentivesAmount_orders_color =
          this.whichNumberIsBigger(
            this.incentiveBarChart.crorderAmount.incentivesAmount.orders,
            this.comparedResponseData.incentivesAmount_orders,
          );

        this.comparedResponseData.controlAmount_visits_color =
          this.whichNumberIsBigger(
            this.incentiveBarChart.crorderAmount.controlAmount.visits,
            this.comparedResponseData.controlAmount_visits,
          );

        this.comparedResponseData.controlAmount_orders_color =
          this.whichNumberIsBigger(
            this.incentiveBarChart.crorderAmount.controlAmount.orders,
            this.comparedResponseData.controlAmount_orders,
          );
      }

      this.combinedLoader(1);
    });
  }

  atrBarChartLoader: boolean = false;

  getChartAtr(dateRange: any, compareDates: boolean = false) {
    this.atrBarChartLoader = true;
    this.service.getBarChartAtc(dateRange).subscribe({
      next: (info) => {
        this.atrBarChartLoader = false;
        if (compareDates) {
          this.combinedLoader(1);

          if (!this.nudgeLite) {
            this.comparedResponseData.barChartAtrDiff =
              this.increaseDecreaseDiff(info.incentives, info.control, true);
          } else {
            if (info.incentives < 0) {
              this.comparedResponseData.barChartAtrDiff =
                '- ' + info.incentives + '%';
            } else {
              this.comparedResponseData.barChartAtrDiff = info.incentives + '%';
            }
          }

          this.comparedResponseData.barChartAtrDiff_color =
            this.whichNumberIsBigger(
              this.barChartAtr[0].diff,
              this.comparedResponseData.barChartAtrDiff,
            );

          return;
        }

        this.receivedInfoAtr = info;

        if (info.incentives == null) {
          info.incentives = 0;
        }
        if (info.control == null) {
          info.control = 0;
        }

        this.barChartAtr[0].value = info.incentives;
        this.barChartAtr[1].value = info.control;

        this.barChartAtr[0].tooltip = this.formatPvalue(info.p);
        this.barChartAtr[0].tooltip_translate = this.formatPvalue(info.p, true);

        if (!this.nudgeLite) {
          this.barChartAtr[0].diff = this.increaseDecreaseDiff(
            info.incentives,
            info.control,
            true,
          );
        } else {
          if (info.incentives < 0) {
            this.barChartAtr[0].diff = '- ' + info.incentives + '%';
          } else {
            this.barChartAtr[0].diff = info.incentives + '%';
          }
        }

        if (this.isChewyTarget) {
          this.barChartAtr[0].name = 'phrases.test_overall';
        } else {
          this.barChartAtr[0].name = 'phrases.nudges_overall';
        }

        this.barChartAtrAxis = this.generateEvenPoints(
          this.barChartAtr,
          5,
        ).reverse();

        if (this.compareObject.isActive) {
          this.comparedResponseData.barChartAtrDiff_color =
            this.whichNumberIsBigger(
              this.barChartAtr[0].diff,
              this.comparedResponseData.barChartAtrDiff,
            );
        }

        this.barChartAtr = this.setProportionalHeights(this.barChartAtr, 90);
      },
      error: (error) => {
        if (compareDates) {
          this.combinedLoader(1);
        }

        this.atrBarChartLoader = false;
        this.barChartAtrAxis = [];
        this.barChartAtr = [
          {
            name: this.isChewyTarget
              ? 'phrases.test_overall'
              : 'phrases.nudges_overall',
            value: 0,
            height: 0,
            diff: 0,
            tooltip: '',
          },
          {
            name: 'words.control',
            value: 0,
            height: 0,
            diff: 0,
          },
        ];
      },
    });
  }

  calcUpliftRaw(inc: any, con: any, visits: any): number {
    var res = (inc - con) * visits;
    return res;
  }

  calcUplift(inc: any, con: any, visits: any) {
    return this.formatCurrencyNumber((inc - con) * visits, true);
  }
  formatNumber(num: any) {
    if (!num || num == 0) return 0;

    num = parseFloat(num.toFixed(2));

    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  getChartRpv(dateRange: any, compareDates: boolean = false) {
    function formatNumber(num: any) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }

    function isDifferenceThreeMonthsOrMore(startDateStr: any, endDateStr: any) {
      const startDateFixed = startDateStr.split('@')[0];
      const endDateFixed = endDateStr.split('@')[0];

      const startDate = new Date(startDateFixed);
      const endDate = new Date(endDateFixed);

      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        throw new Error('Invalid date format');
      }

      const monthsDifference =
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        endDate.getMonth() -
        startDate.getMonth();

      return monthsDifference >= 3;
    }

    if (isDifferenceThreeMonthsOrMore(dateRange.startDate, dateRange.endDate)) {
      dateRange.moreThanThreeMonths = true;

      const startDateString = dateRange.startDate;
      const endDateString = dateRange.endDate;

      const timeZone = this.timezoneService.getTimezone();
      const startDateUTC = new Date(startDateString.split('@')[0]);
      const endDateUTC = new Date(endDateString.split('@')[0]);
      const startDateLocal = convertUTCToLocalDate(startDateUTC, timeZone);
      const endDateLocal = convertUTCToLocalDate(endDateUTC, timeZone);

      let sequences = [];

      let currentDateLocal = new Date(
        startDateLocal.getFullYear(),
        startDateLocal.getMonth(),
        1,
      );

      while (currentDateLocal <= endDateLocal) {
        let monthName = currentDateLocal.toLocaleString('default', {
          month: 'long',
        });

        let startOfMonthLocal = new Date(
          currentDateLocal.getFullYear(),
          currentDateLocal.getMonth(),
          1,
          0,
          0,
        );
        let endOfMonthLocal = new Date(
          currentDateLocal.getFullYear(),
          currentDateLocal.getMonth() + 1,
          0,
          23,
          59,
          59,
        );

        let startDateForMonthLocal =
          currentDateLocal.getMonth() === startDateLocal.getMonth() &&
          currentDateLocal.getFullYear() === startDateLocal.getFullYear()
            ? startDateLocal
            : startOfMonthLocal;

        let endDateForMonthLocal =
          currentDateLocal.getMonth() === endDateLocal.getMonth() &&
          currentDateLocal.getFullYear() === endDateLocal.getFullYear()
            ? endDateLocal
            : endOfMonthLocal;

        let startDateForMonthUTC = convertLocalToUTCDate(
          startDateForMonthLocal,
          timeZone,
        );

        let endDateForMonthUTC = convertLocalToUTCDate(
          endDateForMonthLocal,
          timeZone,
        );

        const adjustedStartDateForMonthUTC = new Date(
          startDateForMonthUTC.getTime() + 2 * 60 * 60 * 1000,
        );
        const adjustedEndDateForMonthUTC = new Date(
          endDateForMonthUTC.getTime() + 2 * 60 * 60 * 1000,
        );

        let formattedStartDate =
          adjustedStartDateForMonthUTC.toISOString() + '@' + timeZone;
        let formattedEndDate =
          adjustedEndDateForMonthUTC.toISOString() + '@' + timeZone;

        if (endDateForMonthLocal < startDateLocal) {
          currentDateLocal.setMonth(currentDateLocal.getMonth() + 1);
          continue;
        }

        sequences.push({
          month: monthName,
          startDate: formattedStartDate,
          endDate: formattedEndDate,
        });

        currentDateLocal.setMonth(currentDateLocal.getMonth() + 1);
      }

      function convertUTCToLocalDate(dateUTC: Date, timeZone: string): Date {
        const dateString = dateUTC.toLocaleString('en-US', { timeZone });
        return new Date(dateString);
      }

      function convertLocalToUTCDate(dateLocal: Date, timeZone: string): Date {
        const dateString = dateLocal.toLocaleString('en-US', {
          timeZone: 'UTC',
        });
        return new Date(dateString);
      }

      dateRange.sequences = JSON.stringify(sequences);
    }

    this.service.getBarChartRpv(dateRange).subscribe((info) => {
      {
        if (compareDates) {
          this.combinedLoader(1);

          if (!this.nudgeLite) {
            this.comparedResponseData.revUplift = this.calcUpliftRaw(
              isNaN(info.incentives) ? 0 : info.incentives,
              isNaN(info.control) ? 0 : info.control,
              isNaN(info.incentivesInfo['visits'])
                ? 0
                : info.incentivesInfo['visits'],
            );

            this.comparedResponseData.barChartRpvDiff =
              this.increaseDecreaseDiff(info.incentives, info.control, true);
          } else {
            this.comparedResponseData.revUplift =
              info.incentivesInfo['revenue'];

            if (info.sumRevenueUpliftCount) {
              this.comparedResponseData.revUplift = info.sumRevenueUpliftCount;
            }

            this.comparedResponseData.barChartRpvDiff =
              this.formatCurrencyNumber(info.incentives);
          }

          setTimeout(() => {
            if (Object.keys(info?.difference).length) {
              this.comparedResponseData.share_revenueShare =
                this.calcUpliftRaw(
                  info.incentives,
                  info.control,
                  info.incentivesInfo['visits'],
                ) /
                (info?.difference?.['rev{}'] ||
                  0 + info?.difference?.['rev{gC=1}'] ||
                  0);

              this.comparedResponseData.share_trafficShare =
                (this.comparedResponseData.visitsIncentive +
                  this.comparedResponseData.visitsControl) /
                (this.comparedResponseData.v + this.comparedResponseData.vgc);

              this.comparedResponseData.share_ordersShare =
                (this.comparedResponseData.ordersIncentive +
                  this.comparedResponseData.ordersControl) /
                (this.comparedResponseData.o + this.comparedResponseData.ogc);
            }

            this.comparedResponseData.share_revenueShare_color =
              this.whichNumberIsBigger(
                this.totalInfo.share.revenueShare,
                this.comparedResponseData.share_revenueShare,
              );

            this.comparedResponseData.share_trafficShare_color =
              this.whichNumberIsBigger(
                this.totalInfo.share.trafficShare,
                this.comparedResponseData.share_trafficShare,
              );

            this.comparedResponseData.share_ordersShare_color =
              this.whichNumberIsBigger(
                this.totalInfo.share.ordersShare,
                this.comparedResponseData.share_ordersShare,
              );
          }, 200);

          this.comparedResponseData.revUplift_color = this.whichNumberIsBigger(
            this.revUplift,
            this.comparedResponseData.revUplift,
          );

          this.comparedResponseData.barChartRpvDiff_color =
            this.whichNumberIsBigger(
              this.barChartRpv[0].diff,
              this.comparedResponseData.barChartRpvDiff,
            );

          return;
        }

        this.receivedInfoRpv = info;

        if (info?.incentives == null && info?.control == null) {
          info.incentives = 0;
          info.control = 0;
        } else {
          info.incentives =
            info.incentivesInfo['revenue'] /
            Number(info.incentivesInfo['visits']);

          info.control =
            info.controlInfo['revenue'] / Number(info.controlInfo['visits']);

          info.incentives = Number(info.incentives.toFixed(2));
          info.control = Number(info.control.toFixed(2));
        }

        var incRev: any;
        var cntRev: any;

        if (this.isVolvoTestDrive) {
          var revenueInc = this.testDriveData.bookedIncentive * 9000;
          var revenueCon = this.testDriveData.bookedControl * 9000;
          incRev = revenueInc / this.testDriveData.matchedIncentive;
          cntRev = revenueCon / this.testDriveData.matchedControl;
          var infVisits = this.testDriveData.matchedIncentive;
        } else {
          incRev = info.incentives;
          cntRev = info.control;
          var infVisits = info.incentivesInfo['visits'];
        }

        if (!this.nudgeLite) {
          this.revUplift = this.calcUpliftRaw(
            isNaN(incRev) ? 0 : incRev,
            isNaN(cntRev) ? 0 : cntRev,
            isNaN(infVisits) ? 0 : infVisits,
          );
        } else {
          this.revUplift = info.incentivesInfo['revenue'];
        }

        if (info.sumRevenueUpliftCount) {
          this.revUplift = info.sumRevenueUpliftCount;
        }

        setTimeout(() => {
          if (Object.keys(this.receivedInfoRpv.difference).length) {
            this.totalInfo.total.totalRevenue = formatNumber(
              (
                this.receivedInfoRpv.difference['rev{}'] +
                this.receivedInfoRpv.difference['rev{gC=1}']
              ).toFixed(2),
            );

            this.totalInfo.difference.revenueIncentive =
              this.receivedInfoRpv.difference['rev{}'];

            this.totalInfo.difference.revenueControl =
              this.receivedInfoRpv.difference['rev{gC=1}'];

            this.totalInfo.share.revenueShare =
              this.calcUpliftRaw(incRev, cntRev, infVisits) /
              (this.receivedInfoRpv.difference['rev{}'] +
                this.receivedInfoRpv.difference['rev{gC=1}']);

            this.totalInfo.share.trafficShare =
              (this.totalInfo.difference.visitsIncentive +
                this.totalInfo.difference.visitsControl) /
              (this.totalInfo.difference.v + this.totalInfo.difference.vgc);

            this.totalInfo.share.ordersShare =
              (this.totalInfo.difference.ordersIncentive +
                this.totalInfo.difference.ordersControl) /
              (this.totalInfo.difference.o + this.totalInfo.difference.ogc);
          }
        }, 200);

        if (this.isVolvoTestDrive) {
          var revenueInc = this.testDriveData.bookedIncentive * 9000;
          var revenueCon = this.testDriveData.bookedControl * 9000;

          this.barChartRpv[0].value = (
            revenueInc / this.testDriveData.matchedIncentive
          ).toFixed(2);
          this.barChartRpv[1].value = (
            revenueCon / this.testDriveData.matchedControl
          ).toFixed(2);
          this.barChartRpv[0].diff = this.increaseDecreaseDiff(
            (revenueInc / this.testDriveData.matchedIncentive).toFixed(2),
            (revenueCon / this.testDriveData.matchedControl).toFixed(2),
            true,
          );
        } else {
          this.barChartRpv[0].value = info.incentives;
          this.barChartRpv[1].value = info.control;

          this.barChartRpv[0].tooltip = this.formatPvalue(info.p);
          this.barChartRpv[0].tooltip_translate = this.formatPvalue(
            info.p,
            true,
          );

          if (!this.nudgeLite) {
            this.barChartRpv[0].diff = this.increaseDecreaseDiff(
              info.incentives,
              info.control,
              true,
            );
          } else {
            this.barChartRpv[0].diff = this.formatCurrencyNumber(
              info.incentives,
            );
          }
        }

        if (this.isChewyTarget) {
          this.barChartRpv[0].name = 'phrases.test_overall';
        } else {
          this.barChartRpv[0].name = 'phrases.nudges_overall';
        }

        this.barChartRpvAxis = this.generateEvenPoints(
          this.barChartRpv,
          5,
        ).reverse();

        this.barChartRpv = this.setProportionalHeights(this.barChartRpv, 90);

        if (
          this.receivedInfoRpv?.defaultObject &&
          (this.selectedOutlier.includes('S. Deviation') ||
            this.selectedOutlier.includes('Default'))
        ) {
          try {
            const height = this.calculateRelativeHeight(
              this.barChartRpv[0].value,
              this.barChartRpv[0].height,
              this.receivedInfoRpv?.defaultObject?.incentives,
            );

            let absHeight = Math.abs(
              parseFloat((this.barChartRpv[0].height - height).toFixed(3)),
            );

            let bottom = parseFloat((height - absHeight).toFixed(3));

            let isLower = false;
            if (
              this.barChartRpv[0].value >
              this.receivedInfoRpv?.defaultObject?.incentives
            ) {
              isLower = true;
              bottom = parseFloat(
                (this.barChartRpv[0].height - absHeight).toFixed(3),
              );
            }

            if (bottom + absHeight > 120) {
              absHeight = 120 - bottom;
            }

            this.barChartRpv[0].default = {
              value: this.receivedInfoRpv?.defaultObject?.incentives,
              height: absHeight,
              bottom: bottom,
              negative: isLower,
            };

            if (this.barChartRpv[1]) {
              const height2 = this.calculateRelativeHeight(
                this.barChartRpv[1].value,
                this.barChartRpv[1].height,
                this.receivedInfoRpv?.defaultObject?.control,
              );

              let absHeight2 = Math.abs(
                parseFloat((this.barChartRpv[1].height - height2).toFixed(3)),
              );

              let bottom2 = parseFloat((height2 - absHeight2).toFixed(3));
              let isLower2 = false;
              if (
                this.barChartRpv[1].value >
                this.receivedInfoRpv?.defaultObject?.control
              ) {
                isLower2 = true;
                bottom2 = parseFloat(
                  (this.barChartRpv[1].height - absHeight2).toFixed(3),
                );
              }

              if (bottom2 + absHeight2 > 120) {
                absHeight2 = 120 - bottom2;
              }

              this.barChartRpv[1].default = {
                value: this.receivedInfoRpv?.defaultObject?.control,
                height: absHeight2,
                bottom: bottom2,
                negative: isLower2,
              };
            }
          } catch (e) {
            console.log(e);
          }
        } else {
          try {
            this.barChartRpv[0].default = null;

            if (this.barChartRpv[1]) {
              this.barChartRpv[1].default = null;
            }
          } catch (e) {
            console.log(e);
          }
        }

        if (this.compareObject.isActive) {
          this.comparedResponseData.revUplift_color = this.whichNumberIsBigger(
            this.revUplift,
            this.comparedResponseData.revUplift,
          );

          this.comparedResponseData.barChartRpvDiff_color =
            this.whichNumberIsBigger(
              this.barChartRpv[0].diff,
              this.comparedResponseData.barChartRpvDiff,
            );

          this.comparedResponseData.share_revenueShare_color =
            this.whichNumberIsBigger(
              this.totalInfo.share.revenueShare,
              this.comparedResponseData.share_revenueShare,
            );

          this.comparedResponseData.share_trafficShare_color =
            this.whichNumberIsBigger(
              this.totalInfo.share.trafficShare,
              this.comparedResponseData.share_trafficShare,
            );

          this.comparedResponseData.share_ordersShare_color =
            this.whichNumberIsBigger(
              this.totalInfo.share.ordersShare,
              this.comparedResponseData.share_ordersShare,
            );
        }

        this.combinedLoader(1);
      }
    });
  }

  checkUpliftColor(data: any) {
    if (data < 0) {
      return false;
    } else if (data > 0) {
      return true;
    } else {
      return 0;
    }
  }

  isNaN(value: any): boolean {
    return isNaN(parseFloat(value));
  }

  safeSum(...values: any[]): number {
    return values.reduce(
      (acc, val) => acc + (this.isNaN(val) ? 0 : parseFloat(val)),
      0,
    );
  }

  getFormattedValue(value: any): string {
    return this.isNaN(value) ? '0.00' : parseFloat(value).toFixed(2);
  }

  getTrafficShare(): string {
    const trafficShare = this.totalInfo.share.trafficShare;
    return this.getFormattedValue(trafficShare);
  }

  getOrdersShare(): string {
    const ordersShare = this.totalInfo.share.ordersShare;
    return this.getFormattedValue(ordersShare);
  }

  isValidDiff(diff: any): boolean {
    if (typeof diff === 'string' && diff.includes('NaN')) {
      return false;
    }
    const numericValue = parseFloat(diff);
    return !isNaN(numericValue) && numericValue > 0;
  }

  getChartRr(dateRange: any, compareDates: boolean = false) {
    this.service.getBarChartRr(dateRange).subscribe((info) => {
      this.receivedInfoRr = info;

      if (this.isChewyTarget) {
        this.barChartRR[0].name = 'phrases.test_overall';
      } else {
        this.barChartRR[0].name = 'phrases.nudges_overall';
      }

      if (!info) {
        this.receivedInfoRrNull = true;
        this.combinedLoader(1);
        return;
      }

      if (info?.incentives == null && info?.control == null) {
        this.receivedInfoRrNull = true;
        info.incentives = 0;
        info.control = 0;
      } else {
        this.receivedInfoRrNull = false;
      }
      if (info.incentives == null) {
        info.incentives = 0;
      }
      if (info.control == null) {
        info.control = 0;
      }
      var tmpData = [];
      tmpData.push(info.incentives, info.control);

      this.barChartRR[0].value = info.incentives;
      this.barChartRR[1].value = info.control;
      this.barChartRR[0].diff = this.increaseDecreaseDiff(
        info.incentives,
        info.control,
        true,
      );
      this.barChartRR[0].tooltip = this.formatPvalue(info.p);
      this.barChartRR[0].tooltip_translate = this.formatPvalue(info.p, true);

      this.barChartRRAxis = this.generateEvenPoints(
        this.barChartRR,
        5,
      ).reverse();

      this.barChartRR = this.setProportionalHeights(this.barChartRR, 90);

      this.combinedLoader(1);
    });
  }
  getChartAov(dateRange: any, compareDates: boolean = false) {
    this.service.getBarChartAov(dateRange).subscribe((info) => {
      if (compareDates) {
        this.combinedLoader(1);

        if (!this.nudgeLite) {
          this.comparedResponseData.barChartAovDiff = this.increaseDecreaseDiff(
            info.incentives,
            info.control,
            true,
          );
        } else {
          this.comparedResponseData.barChartAovDiff = this.formatCurrencyNumber(
            info.incentives,
          );
        }

        this.comparedResponseData.barChartAovDiff_color =
          this.whichNumberIsBigger(
            this.barChartAov[0].diff,
            this.comparedResponseData.barChartAovDiff,
          );

        return;
      }

      this.receivedInfoAov = info;
      if (info.incentives == null && info.control == null) {
        info.incentives = 0;
        info.control = 0;
      } else {
        info.incentives =
          info.incentivesInfo['revenue'] /
          Number(info.incentivesInfo['orders']);

        info.control =
          info.controlInfo['revenue'] / Number(info.controlInfo['orders']);

        info.incentives = Number(info.incentives.toFixed(2));
        info.control = Number(info.control.toFixed(2));
      }

      if (isNaN(info.incentives)) info.incentives = 0;
      if (isNaN(info.control)) info.control = 0;

      var tmpData = [];

      var incRev: any;
      var cntRev: any;

      if (this.isVolvoTestDrive) {
        var revenueInc = this.testDriveData.bookedIncentive * 9000;
        var revenueCon = this.testDriveData.bookedControl * 9000;
        incRev = revenueInc / this.testDriveData.bookedIncentive;
        cntRev = revenueCon / this.testDriveData.bookedControl;

        tmpData.push(incRev, cntRev);

        this.barChartAov[0].value = incRev;
        this.barChartAov[1].value = cntRev;
        this.barChartAov[0].diff = this.increaseDecreaseDiff(
          incRev,
          cntRev,
          true,
        );
      } else {
        tmpData.push(info.incentives, info.control);

        this.barChartAov[0].value = info.incentives;
        this.barChartAov[1].value = info.control;

        this.barChartAov[0].tooltip = this.formatPvalue(info.p);
        this.barChartAov[0].tooltip_translate = this.formatPvalue(info.p, true);

        if (!this.nudgeLite) {
          this.barChartAov[0].diff = this.increaseDecreaseDiff(
            info.incentives,
            info.control,
            true,
          );
        } else {
          this.barChartAov[0].diff = this.formatCurrencyNumber(info.incentives);
        }
      }

      if (this.isChewyTarget) {
        this.barChartAov[0].name = 'phrases.test_overall';
      } else {
        this.barChartAov[0].name = 'phrases.nudges_overall';
      }

      this.barChartAovAxis = this.generateEvenPoints(
        this.barChartAov,
        5,
      ).reverse();

      this.barChartAov = this.setProportionalHeights(this.barChartAov, 90);

      if (
        this.receivedInfoAov?.defaultObject &&
        (this.selectedOutlier.includes('S. Deviation') ||
          this.selectedOutlier.includes('Default'))
      ) {
        try {
          const height = this.calculateRelativeHeight(
            this.barChartAov[0].value,
            this.barChartAov[0].height,
            this.receivedInfoAov?.defaultObject?.incentives,
          );

          let absHeight = Math.abs(
            parseFloat((this.barChartAov[0].height - height).toFixed(3)),
          );

          let bottom = parseFloat((height - absHeight).toFixed(3));

          let isLower = false;
          if (
            this.barChartAov[0].value >
            this.receivedInfoAov?.defaultObject?.incentives
          ) {
            isLower = true;
            bottom = parseFloat(
              (this.barChartAov[0].height - absHeight).toFixed(3),
            );
          }

          if (bottom + absHeight > 120) {
            absHeight = 120 - bottom;
          }

          this.barChartAov[0].default = {
            value: this.receivedInfoAov?.defaultObject?.incentives,
            height: absHeight,
            bottom: bottom,
            negative: isLower,
          };

          if (this.barChartAov[1]) {
            const height2 = this.calculateRelativeHeight(
              this.barChartAov[1].value,
              this.barChartAov[1].height,
              this.receivedInfoAov?.defaultObject?.control,
            );

            let absHeight2 = Math.abs(
              parseFloat((this.barChartAov[1].height - height2).toFixed(3)),
            );

            let bottom2 = parseFloat((height2 - absHeight2).toFixed(3));

            let isLower2 = false;
            if (
              this.barChartAov[1].value >
              this.receivedInfoAov?.defaultObject?.control
            ) {
              isLower2 = true;
              bottom2 = parseFloat(
                (this.barChartAov[1].height - absHeight2).toFixed(3),
              );
            }

            if (bottom2 + absHeight2 > 120) {
              absHeight2 = 120 - bottom2;
            }

            this.barChartAov[1].default = {
              value: this.receivedInfoAov?.defaultObject?.control,
              height: absHeight2,
              bottom: bottom2,
              negative: isLower2,
            };
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          this.barChartAov[0].default = null;

          if (this.barChartAov[1]) {
            this.barChartAov[1].default = null;
          }
        } catch (e) {
          console.log(e);
        }
      }

      if (this.compareObject.isActive) {
        this.comparedResponseData.barChartAovDiff_color =
          this.whichNumberIsBigger(
            this.barChartAov[0].diff,
            this.comparedResponseData.barChartAovDiff,
          );
      }

      this.combinedLoader(1);
    });
  }
  getChartNr(dateRange: any, compareDates: boolean = false) {
    this.service.getBarChartNsv(dateRange).subscribe((info) => {
      this.receivedInfoNrv = info;

      if (this.isChewyTarget) {
        this.barChartNR[0].name = 'phrases.test_overall';
      } else {
        this.barChartNR[0].name = 'phrases.nudges_overall';
      }

      if (info != null) {
        if (info.incentives == null && info.control == null) {
          this.receivedInfoNrNull = true;
          info.incentives = 0;
          info.control = 0;
        } else {
          this.receivedInfoNrNull = false;
        }

        if (info.incentives == null) {
          info.incentives = 0;
        }
        if (info.control == null) {
          info.control = 0;
        }
        var tmpData = [];
        tmpData.push(info.incentives, info.control);

        this.barChartNR[0].value = info.incentives;
        this.barChartNR[1].value = info.control;
        this.barChartNR[0].diff = this.increaseDecreaseDiff(
          info.incentives,
          info.control,
          true,
        );
        this.barChartNR[0].tooltip = this.formatPvalue(info.p);
        this.barChartNR[0].tooltip_translate = this.formatPvalue(info.p, true);

        this.barChartNRAxis = this.generateEvenPoints(
          this.barChartNR,
          5,
        ).reverse();

        this.barChartNR = this.setProportionalHeights(this.barChartNR, 90);

        this.combinedLoader(1);
      } else {
        this.receivedInfoNrNull = true;
        this.combinedLoader(1);
      }
    });
  }

  platformChanged(event: any) {
    this.chartLoader = false;
    this.loadNrIndicator = 0;
    this.getChartInfo();
  }

  selectionDashboardViewChanged() {
    this.chartLoader = false;
    this.loadNrIndicator = 0;

    // this.raisinInvestmentViewSelected =
    //   this.selectedDashboardView == 'investments';

    // this.getChartInfo();
    const selectedName = this.coreTargetService.getSelectedTarget('name');
    this.selectorService.selectedStore(selectedName);
  }

  selectionDeviceChanged(event: any) {
    this.incentiveBarChart.selectedPlatform = event.value;
    this.chartLoader = false;
    this.loadNrIndicator = 0;

    sessionStorage.setItem(
      'selectedPlatform',
      this.incentiveBarChart.selectedPlatform == 'overall'
        ? 'overall'
        : this.incentiveBarChart.selectedPlatform,
    );

    // if (this.nudgeLite) {
    //   this.fetchDataFromServer();
    // }

    // this.getChartInfo();
    const selectedName = this.coreTargetService.getSelectedTarget('name');
    this.selectorService.selectedStore(selectedName);
  }

  filterVisits(event: any) {
    this.incentiveBarChart.selectedFilter = event.value;
    this.chartLoader = false;
    this.loadNrIndicator = 0;

    sessionStorage.setItem(
      'selectedFilter',
      this.incentiveBarChart.selectedFilter == 'overall'
        ? 'overall'
        : this.incentiveBarChart.selectedFilter,
    );

    // if (this.nudgeLite) {
    //   this.fetchDataFromServer();
    // }

    // this.getChartInfo();

    const selectedName = this.coreTargetService.getSelectedTarget('name');
    this.selectorService.selectedStore(selectedName);
  }

  onOutlierChange(value: any) {
    this.chartLoader = false;
    this.loadNrIndicator = 0;
    this.getChartInfo();
  }

  isEmpty(obj: any) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  combinedLoader(num: any) {
    this.loadNrIndicator = this.loadNrIndicator + num;

    let totalLoadIndicator = 5;

    if (this.nudgeLite) {
      totalLoadIndicator = 6;
    }

    if (this.raisinInvestmentViewSelected) {
      totalLoadIndicator = 1;
    }

    if (this.loadNrIndicator == totalLoadIndicator) {
      setTimeout(() => {
        this.firstLoader = true;
        this.chartLoader = true;
        this.initialLoader = false;
      }, 400);
    }
  }

  generateReport(type: string) {
    this.chartLoader = false;
    var device;
    if (type == 'report') {
      device = 'all';
    } else {
      if (this.incentiveBarChart.selectedPlatform == 'overall') {
        device = '';
      } else {
        device = this.incentiveBarChart.selectedPlatform;
      }
    }
    var visitType;
    if (this.incentiveBarChart.selectedFilter == 'overall') {
      visitType = '';
    } else {
      visitType = this.incentiveBarChart.selectedFilter;
    }

    // Outlier Data
    var outliers;
    if (this.selectedOutlier == 'Default') {
      outliers = false;
    } else {
      outliers = true;
    }

    var dateRange = {
      startDate: this.startDate,
      endDate: this.endDate,
      target: this.coreTargetService.getSelectedTarget('target'),
      device: device,
      visitType: visitType,
      noOutliers: outliers,
      reportType: 'Overall',
    };

    this.service
      .downloadOverallReport(dateRange)
      .subscribe((response: HttpResponse<Blob>) => {
        this.chartLoader = true;
        let filename = this.targetName;
        if (type == 'report') {
          filename += ' Overall Report.xlsx';
        } else {
          filename += ' Overall Monthly Report.xlsx';
        }
        let binaryData: any[] = [];
        binaryData.push(response.body);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(
          new Blob(binaryData, { type: 'blob' }),
        );
        downloadLink.setAttribute('download', filename);
        downloadLink.click();
      });
  }

  generateRawData() {
    function extractNumbersFromString(str: any) {
      const numericString = str.match(/[0-9.]+/g)?.join('') || '';
      return parseFloat(numericString) || 0;
    }
    const dowloadFunc = (link: string) => {
      let target = this.coreTargetService.getSelectedTarget('target');
      let filename = this.targetName + ' Report';
      let binaryData: any[] = [];
      binaryData.push(link);
      let downloadLink = document.createElement('a');
      downloadLink.href = `https://behamicsfront.blob.core.windows.net/rawdatacsv/${target}/${link}`;
      window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
      downloadLink.setAttribute('download', filename);
      downloadLink.click();
      this.rawDataButtonDisabled = false;
      downloadLink?.remove();
    };

    let device = 'all';
    if (this.incentiveBarChart.selectedPlatform !== 'overall') {
      device = this.incentiveBarChart.selectedPlatform;
    }

    let incV = extractNumbersFromString(
      this.incentiveBarChart.crorderAmount.incentivesAmount.visits,
    );
    let incG = extractNumbersFromString(
      this.incentiveBarChart.crorderAmount.controlAmount.visits,
    );

    const startDate =
      this.localStorageService.get('startDate') || this.startDate;
    const endDate = this.localStorageService.get('endDate') || this.endDate;

    let params = `target=${this.coreTargetService.getSelectedTarget(
      'target',
    )}&startDate=${startDate}&endDate=${endDate}&device=${device}&incV=${incV}&incG=${incG}`;

    this.rawDataButtonDisabled = true;

    this.service.downloadRawData(params).subscribe({
      next: (response) => {
        if (response) {
          dowloadFunc(response.fileName);
        }
      },
      error: (error) => {
        this.rawDataButtonDisabled = false;

        if (error?.error?.text) {
          dowloadFunc(error?.error?.text);
        }
      },
    });
  }
  formatCurrencyNumber(value: number, showPlusSign: boolean = false) {
    return this.currencyPipe.transform(value, showPlusSign);
  }
  runLineChart() {
    var today = new Date();
    today.setHours(0, 0, 0);

    this.fetchDataFromServer();
  }

  getStartDateLine(date: any) {
    this.selectedRangeValue = 'custom';
    var stoday = new Date();

    this.isMonthDisabled = false;
    this.endMinDate = date;

    this.fetchDataFromServer();
  }

  getEndDateLine(date: any) {
    var stoday = new Date();
    this.selectedRangeValue = 'custom';

    var nowDate = new Date();
    this.isMonthDisabled = false;

    if (
      date.getFullYear() == nowDate.getFullYear() &&
      date.getMonth() == nowDate.getMonth() &&
      date.getDate() == nowDate.getDate()
    ) {
      date.setHours(nowDate.getHours(), 59, 59);
    } else {
      date.setHours(23, 59, 59);
    }

    this.startMaxDate = date;

    this.fetchDataFromServer();
  }

  getStartDateFormat() {
    var today = new Date();
    today.setHours(0, 0, 0);

    return today;
  }
  onRateChangeLine(value: any) {
    this.selectedRangeValue = this.localStorageService.get('rangeValue');

    if (value.value == 'hourly') {
      // this.rate = 'hourly';
      if (this.selectedRangeValue == 'today') {
        var startDate = new Date();
        startDate.setHours(0, 0, 0);
        this.startDate =
          startDate.toISOString() +
          '@' +
          Intl.DateTimeFormat().resolvedOptions().timeZone;
      } else if (this.selectedRangeValue == 'yestarday') {
        var startDate = new Date();
        startDate.setHours(0, 0, 0);
        startDate.setDate(startDate.getDate() - 1);
        this.startDate =
          startDate.toISOString() +
          '@' +
          Intl.DateTimeFormat().resolvedOptions().timeZone;

        var endDate = new Date();
        endDate.setHours(23, 59, 59);
        endDate.setDate(endDate.getDate() - 1);
        this.endDate =
          endDate.toISOString() +
          '@' +
          Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
    } else if (value.value == 'day') {
      // this.rate = 'day';
      if (this.selectedRangeValue == 'today') {
        var startDate = new Date();
        startDate.setHours(0, 0, 0);
        startDate.setDate(startDate.getDate() - 1);
        this.startDate =
          startDate.toISOString() +
          '@' +
          Intl.DateTimeFormat().resolvedOptions().timeZone;

        var endDate = new Date();
        this.endDate =
          endDate.toISOString() +
          '@' +
          Intl.DateTimeFormat().resolvedOptions().timeZone;
      } else if (this.selectedRangeValue == 'yestarday') {
        var startDate = new Date();
        startDate.setHours(0, 0, 0);
        startDate.setDate(startDate.getDate() - 2);
        this.startDate =
          startDate.toISOString() +
          '@' +
          Intl.DateTimeFormat().resolvedOptions().timeZone;

        var endDate = new Date();
        endDate.setHours(23, 59, 59);
        endDate.setDate(endDate.getDate() - 1);
        this.endDate =
          endDate.toISOString() +
          '@' +
          Intl.DateTimeFormat().resolvedOptions().timeZone;
      }
    }
    this.rate = value.value;
    this.chartLoaderSecondary = false;
    this.fetchDataFromServer();
  }

  fetchDataFromServer(compareDates: boolean = false) {
    if (!this.nudgeLite) return;

    const obj = {
      startDate: compareDates ? this.compareObject.startDate : this.startDate,
      endDate: compareDates ? this.compareObject.endDate : this.endDate,
      rate: this.rate,
      selectedRangeValue: this.selectedRangeValue,
      target: this.coreTargetService.getSelectedTarget('target'),
      device:
        this.incentiveBarChart.selectedPlatform == 'overall'
          ? ''
          : this.incentiveBarChart.selectedPlatform,
      visitType:
        this.incentiveBarChart.selectedFilter == 'overall'
          ? ''
          : this.incentiveBarChart.selectedFilter,
    };

    this.service.getNudgeLitePlots(obj).subscribe(
      (res: any) => {
        this.chartLoaderSecondary = true;

        if (!res?.error) {
          this.incentiveData = res;
        } else {
          this.incentiveData = null;
        }
        this.updateIncentiveLineChart();
      },
      (error: any) => {
        this.chartLoaderSecondary = true;
        console.error('API Error:', error);
      },
    );
  }

  updateIncentiveLineChart() {
    function formatNumber(num: any) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    function formatDateFull(date: any) {
      if (date.length > 11) {
        var x = date.slice(0, -3) + 'T' + date.slice(-2) + ':00:00';
        var MM = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ];
        var xx = x.replace(
          /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):\d{2}/,
          function ($0, $1, $2, $3, $4, $5) {
            var ampm12 = $4 >= 12 ? 'PM' : 'AM';
            $4 = $4 % 12;
            $4 = $4 ? $4 : 12;
            return MM[$2 - 1] + ' ' + $3 + ', ' + $1 + ' - ' + $4 + ampm12;
          },
        );
        return xx;
      } else if (date.length > 8) {
        var xd = date;
        var MMd = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ];
        var xxd = xd.replace(
          /(\d{4})-(\d{2})-(\d{2})/,
          function ($0: any, $1: any, $2: any, $3: any) {
            return MMd[$2 - 1] + ' ' + $3 + ', ' + $1;
          },
        );
        return xxd;
      } else {
        var xm = date;
        var MMm = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ];
        var xxm = xm.replace(
          /(\d{4})-(\d{2})/,
          function ($0: any, $1: any, $2: any, $3: any) {
            return MMm[$2 - 1] + ', ' + $1;
          },
        );
        return xxm;
      }
    }
    var triggerOne = false;
    function formatAMPM(date: any) {
      if (date.length > 11) {
        var x = date.slice(0, -3) + 'T' + date.slice(-2) + ':00:00';
        var MM = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ];
        var xx = x.replace(
          /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):\d{2}/,
          function ($0, $1, $2, $3, $4, $5) {
            var ampm12 = $4 >= 12 ? 'PM' : 'AM';
            $4 = $4 % 12;
            $4 = $4 ? $4 : 12;
            return $4 + ampm12;
          },
        );
        return xx;
      } else if (date.length > 8) {
        var xd = date;
        var MMd = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];
        var xxd = xd.replace(
          /(\d{4})-(\d{2})-(\d{2})/,
          function ($0: any, $1: any, $2: any, $3: any) {
            return MMd[$2 - 1] + ' ' + $3;
          },
        );
        return xxd;
      } else {
        var xm = date;
        var MMm = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];
        var xxm = xm.replace(
          /(\d{4})-(\d{2})/,
          function ($0: any, $1: any, $2: any, $3: any) {
            return MMm[$2 - 1] + ', ' + $1;
          },
        );
        return xxm;
      }
    }

    // Initialize Line Chart Data
    let incLineData = [
      [
        this.translate.instant('words.time'),
        this.translate.instant('words.visits'),
        this.translate.instant('phrases.click_throughs'),
        this.translate.instant('phrases.adds_to_cart'),
        this.translate.instant('words.conversions'),
        { role: 'tooltip', p: { html: true } },
      ],
    ];

    if (!this.incentiveData) {
      this.incentivesLineChart.dataTable = [
        [
          this.translate.instant('words.time'),
          this.translate.instant('words.visits'),
          this.translate.instant('phrases.click_throughs'),
          this.translate.instant('phrases.adds_to_cart'),
          this.translate.instant('words.conversions'),
          {
            role: 'tooltip',
            p: {
              html: true,
              role: 'tooltip',
            },
          },
        ],
        [
          {
            v: '---',
            f: '---',
          },
          0,
          0,
          0,
          0,
          '',
        ],
      ];

      this.incentivesLineChart.options['pointSize'] = 0;
      this.incentivesLineChart.options['vAxis'].title = '';
      this.incentivesLineChart.options['hAxis'].title = '';
      this.incentivesLineChart.options['vAxis'].viewWindow.max = 10;
      this.incentivesLineChart.options['tooltip'].trigger = 'none';
      this.incentivesLineChart.component?.draw(this.incentivesLineChart);
      this.combinedLoader(1);
      return;
    }
    this.incentivesLineChart.options['tooltip'].trigger = 'hover';

    const generateTooltip = (label: string, value: number): string => {
      return `<p><b>${label}:</b> ${formatNumber(value)}</p>`;
    };

    this.incentiveData?.labels.forEach((dateLabel: string, i: number) => {
      const visits = this.incentiveData.data.visits?.[i] || 0;
      const clickthroughs = this.incentiveData.data.clickthrough?.[i] || 0;
      const atc = this.incentiveData.data.atc?.[i] || 0;
      const conversions = this.incentiveData.data.conversion?.[i] || 0;

      const visitsTooltip = generateTooltip(
        this.translate.instant('words.visits'),
        visits,
      );
      const clickthroughsTooltip = generateTooltip(
        this.translate.instant('phrases.click_throughs'),
        clickthroughs,
      );
      const atcTooltip = generateTooltip(
        this.translate.instant('phrases.adds_to_cart'),
        atc,
      );
      const conversionsTooltip = generateTooltip(
        this.translate.instant('words.conversions'),
        conversions,
      );

      const tmp_tooltip = `<div class='tooltip-text'>${
        visitsTooltip + clickthroughsTooltip + atcTooltip + conversionsTooltip
      }</div>`;

      const rowData = [
        { v: dateLabel, f: formatAMPM(dateLabel) },
        visits,
        clickthroughs,
        atc,
        conversions,
        tmp_tooltip,
      ];

      incLineData.push(rowData);
    });

    // Determine max value for Y-axis scaling
    const maxData: number[] = [];
    for (const key in this.incentiveData.data) {
      if (Array.isArray(this.incentiveData.data[key])) {
        maxData.push(...this.incentiveData.data[key]);
      }
    }

    this.incentivesLineChart.options.colors = this.linechartColorsNudgeLite;

    var maxVal = Math.max(...maxData);

    if (maxVal == 0) {
      this.incentivesLineChart.options['vAxis'].viewWindow.max = 10;
    } else {
      this.incentivesLineChart.options['vAxis'].viewWindow.max = '';
    }
    if (maxVal > 1000000) {
      this.incentivesLineChart.options['vAxis'].format = 'short';
    } else {
      this.incentivesLineChart.options['vAxis'].format = 'decimal';
    }

    // Adjust point size based on data density
    const pointLength = this.incentiveData.labels.length;
    this.incentivesLineChart.options.pointSize = pointLength >= 45 ? 0 : 2;

    this.incentivesLineChart.dataTable = [];
    // Update chart with new data
    this.incentivesLineChart.dataTable = incLineData;

    this.incentivesLineChart.options['hAxis'].viewWindow.max =
      this.incentiveData.labels.length - 0.5;

    this.incentivesLineChart.component?.draw(this.incentivesLineChart);

    setTimeout(() => {
      this.incentivesLineChart.component?.draw(this.incentivesLineChart);
    }, 100);

    this.combinedLoader(1);
  }

  public incentivesLineChart: GoogleChartInterface = {
    chartType: 'LineChart',
    dataTable: [],
    options: {
      legend: {
        position: 'top',
        maxLines: 2,
        alignment: 'center',
        textStyle: {
          fontSize: 11,
          fontName: 'Roboto, sans-serif',
          color: '#666',
        },
      },
      pointSize: 0,
      crosshair: {
        trigger: 'focus',
        orientation: 'vertical',
        color: '#eeeeee',
      },
      series: {
        0: {
          targetAxisIndex: 0,
          areaOpacity: 0.1,
          color: this.linechartColorsNudgeLite[0],
          type: 'line',
        },
      },
      forceIFrame: false,
      focusTarget: 'category',
      colors: this.linechartColorsNudgeLite,
      height: 200,
      vAxis: {
        minValue: 0,
        baseline: 0,
        viewWindow: {
          min: 0,
        },
        baselineColor: '#c0c0c0',
        gridlineColor: '#ededed',
        textStyle: {
          fontSize: 13,
          fontName: 'Roboto, sans-serif',
          color: '#666',
        },
      },
      tooltip: {
        textStyle: {
          fontSize: 12,
        },
        isHtml: true,
      },
      hAxis: {
        textStyle: {
          fontSize: 11,
          fontName: 'Roboto, sans-serif',
          color: '#666',
        },
        viewWindow: {
          min: 0.5,
        },
      },
      chartArea: {
        height: '90%',
        top: 20,
        left: 60,
        right: 20,
        bottom: 55,
        width: '90%',
      },
    },
  };
  onResize(event: any) {
    // Rebuild charts so they are responsive
    this.incentivesLineChart.component?.draw(this.incentivesLineChart);
  }
}
